module.exports = __WEBPACK_EXTERNAL_MODULE__24634__;